import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as search from "./search";

const initialState: State = {
  search: search.initialState,
};

const reduceState = combineStateReducer(initialState, {
  search: search.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...search.createSelector(() => getState().search),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
